import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";


import { SCProfile } from "./css";

import { loadPageData } from "../../actions";
import ProfileForm from "./ProfileForm";
import Loader from "../Common/Loader";
import Footer from "../Footer";
import { NavWithComponent } from "../Nav";

interface ProfileProps {
  customerId?: any;
  loadPageData(): void;
  customer?: any;
  title: string;
  firstName: string;
  lastName: string;
  email: string;
  confirmEmail: string;
  phoneMobile: string;
  dateOfBirth: string;
  street: string;
  suburb: string;
  state: string;
  postcode: string;
  residentialStatus: string;
  employmentType: string;
  employerName: string;
  employerPhoneNumber: string;
  timeInJob: string;
  paymentFrequency: string;
  totalIncome: string;
  otherIncome: string;
  licenseNo: string;
  licenceState: string;
  expiry: string;
}

class Profile extends React.Component<ProfileProps> {
  componentDidMount() {
    if (this.props.customer === null) {
      this.props.loadPageData();
    }
  }

  render() {
    if (this.props.customer) {
      return (
        <SCProfile>
          <div className="profile-content">
            <NavWithComponent title="Account Profile" activePage="account" />
            <ProfileForm />
          </div>
          <Footer />
        </SCProfile>
      );
    } else {
      return <Loader text="Fetching customer details..." />;
    }
  }
}

const mapStateToProps = state => {
  return {
    customerId: state.auth.customerId,
    token: state.auth.authToken,
    isSignedIn: state.auth.isSignedIn,
    customer: state.pageData.customer
  };
};

export default withRouter(connect(mapStateToProps, { loadPageData })(Profile));
